/* A single opening reveal. Scrolling remains native; reduced motion stays static. */
(() => {
  const scenes = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame;
  function draw() {
    frame = null;
    scenes.forEach((root) => {
      const rect = root.getBoundingClientRect();
      const progress = reduced.matches ? 0 : Math.min(1, Math.max(0, -rect.top / rect.height));
      root.style.setProperty('--scene-progress', progress);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(draw); }
  function mount(scope) {
    scope.querySelectorAll('.mr-editorial--hero[data-maroni-scene]').forEach(root => {
      scenes.set(root.id, root);
      root.classList.add('mr-scene-ready');
    });
    schedule();
  }
  mount(document);
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  reduced.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', e => mount(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-maroni-scene]').forEach(root => scenes.delete(root.id));
  });
})();
